// ─── Contenu d'aide du module Calendrier ─────────────────────────
// Registry PROPRE au module (indépendance) : l'app le compose avec les autres
// modules et le passe à <AideProvider contenus={…}>. Clés = clés de fonctions.
// Les champs sont des CLÉS i18n (section aideCal du catalogue) : AideFonction
// les traduit au rendu (FR/EN) — le contenu vit dans locales/fr.json + en.json.
export const AIDES_CALENDRIER = {
  calendrier: {
    emoji: '📅', titre: 'aideCal.titreCal',
    intro: 'aideCal.introCal',
    sections: [
      { titre: 'aideCal.s1t', texte: 'aideCal.s1x' },
      { titre: 'aideCal.s2t', texte: 'aideCal.s2x' },
      { titre: 'aideCal.s3t', texte: 'aideCal.s3x' },
      { titre: 'aideCal.s4t', texte: 'aideCal.s4x' },
      { titre: 'aideCal.s5t', texte: 'aideCal.s5x' },
    ],
    tutos: [{
      titre: 'aideCal.tutoT',
      etapes: ['aideCal.tutoE1', 'aideCal.tutoE2', 'aideCal.tutoE3'],
    }],
  },
  'calendrier.vacances': {
    emoji: '🏖️', titre: 'aideCal.titreVac',
    intro: 'aideCal.introVac',
    sections: [
      { titre: 'aideCal.vac1t', texte: 'aideCal.vac1x' },
      { titre: 'aideCal.vac2t', texte: 'aideCal.vac2x' },
    ],
  },
  'calendrier.gardes': {
    emoji: '🗓️', titre: 'aideCal.titreGardes',
    intro: 'aideCal.introGardes',
    sections: [
      { titre: 'aideCal.g1t', texte: 'aideCal.g1x' },
      { titre: 'aideCal.g2t', texte: 'aideCal.g2x' },
    ],
  },
  'calendrier.demandes': {
    emoji: '🧷', titre: 'aideCal.titreDem',
    intro: 'aideCal.introDem',
    sections: [
      { titre: 'aideCal.d1t', texte: 'aideCal.d1x' },
      { titre: 'aideCal.d2t', texte: 'aideCal.d2x' },
    ],
  },
};

export default AIDES_CALENDRIER;
